module.exports = __webpack_public_path__ + "img/headshot-alexa-idama@2x.a293dd47.jpg";